import {Dispatch} from "redux";
import {StatusCode} from "status-code-enum";
import {setAlert} from "../actions/alert";
import {AlertTypes} from "./alert.utils";

export const errorHandler = (err: any & Error, dispatch: Dispatch<any>, customMessage?: string) => {
    let msg: string = "";

    if (customMessage) {
        msg = customMessage;
    } else {
        switch (err.response.status) {
            case StatusCode.ClientErrorBadRequest:
                msg = "Invalid credentials, please check and try again..."
                break;
            case StatusCode.ClientErrorUnauthorized:
                msg = "Unauthorized action..."
                break;

            case StatusCode.ServerErrorInternal:
                msg = "Something went wrong. Please reach out the dev team for fix."
                break;

            default:
                break;

        }
    }

    if (msg !== "") {
        dispatch(setAlert(msg, AlertTypes.FAILURE));
    }

}
